export function oneOloaderHtml() {
  return `
<style style="display: none">
.io-1o-Container,
.io-1o-Container:before,
.io-1o-Container:after,
.io-1o-Container:first-letter,
.io-1o-Container:first-line { all: initial }
.io-1o-Container { display: block; opacity: 0; transition: .3s opacity; z-index: calc(9e999); }
.io-1o-Container *,
.io-1o-Container *:before,
.io-1o-Container *:after,
.io-1o-Container *:first-letter,
.io-1o-Container *:first-line { all: unset }
.io-1o-Container div { text-align: center; display: block }
.io-1o-Container-content { position: absolute; background: #fff; opacity: 1; transition: .3s opacity; }
.io-1o-Container-body { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) }
.io-1o-Container-border { position: absolute; top: 0; left: 0; right: 0; bottom: 0; border-radius: inherit; border-style: solid }
.io-1o-Checkout-button .io-1o-Container-border,
.io-1o-Checkout-button .io-1o-Container-body { display: none }
.io-1o-Checkout-button .io-1o-Container-content { background: transparent }
.io-1o-Container iframe { position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; visibility: hidden }
.io-1o-Container-show { opacity: 1 }

.io-1o-Container-loader,
.io-1o-Container-loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.io-1o-Container-loader {
  position: relative;
  margin: 60px auto;
  border-top: 0.4em solid rgba(0, 0, 0, 0.1);
  border-right: 0.4em solid rgba(0, 0, 0, 0.1);
  border-bottom: 0.4em solid rgba(0, 0, 0, 0.1);
  border-left: 0.4em solid #000000;
  font-size: 8px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: io-1o-Container-circleRotation 2s infinite linear;
  animation: io-1o-Container-circleRotation 2s infinite linear;
}
.io-1o-Container.io-1o-Checkout-rightTray .io-1o-Container-loader {
    font-size: 11px;
}
@-webkit-keyframes io-1o-Container-circleRotation {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes io-1o-Container-circleRotation {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.io-1o-Container.io-1o-Checkout-rightTray {
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  min-height: 100vh;
  min-height: fill-available;
  min-height: -webkit-fill-available;
  filter: drop-shadow(-4px 0px 16px #0000001f);
  pointer-events: all;
  z-index: calc(9e999);
}
.io-1o-Container.io-1o-Checkout-rightTray .io-1o-Container-content {
  width: 360px !important;
  height: 100vh !important;
  animation: slidein 250ms;
}

@keyframes slidein {
  from { right: -360px; }
  to { right: 0px; }
}
@media (max-width: 768px) {
  .io-1o-Container.io-1o-Checkout-rightTray {
    width: 100vw;
    right: 0;
  }
  .io-1o-Container.io-1o-Checkout-rightTray .io-1o-Container-content {
    width: 100vw;
  }
  @keyframes slidein {
  from { right: -100vw; }
  to { right: 0px; }

  }
}
</style>
<iframe allow="payment" data-hj-allow-iframe="true"></iframe>
<div class="io-1o-Container-content">
    <div class="io-1o-Container-border"></div>
    <div class="io-1o-Container-body">
        <div class="io-1o-Container-loader"></div>
    </div>
</div>`
}
